import { render, staticRenderFns } from "./Handover.vue?vue&type=template&id=a9850098&scoped=true&"
import script from "./Handover.vue?vue&type=script&lang=js&"
export * from "./Handover.vue?vue&type=script&lang=js&"
import style0 from "./Handover.vue?vue&type=style&index=0&id=a9850098&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9850098",
  null
  
)

export default component.exports